import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'antd';

const Card = styled.div`
  background: white;
  border-radius: 8px;
  padding: 16px;
  flex: 1;
  min-width: 140px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  gap: 8px;
  opacity: ${props => props.disabled ? 0.5 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};

  &:hover {
    box-shadow: ${props => props.disabled ? '0 2px 8px rgba(0, 0, 0, 0.06)' : '0 4px 16px rgba(0, 0, 0, 0.1)'};
    transform: ${props => props.disabled ? 'none' : 'translateY(-2px)'};
    border-color: ${props => props.disabled ? '#f0f0f0' : (props.color || '#d9d9d9')};
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const Icon = styled.div`
  color: ${props => props.color || '#666'};
  font-size: 16px;
  display: flex;
  align-items: center;
`;

const Title = styled.div`
  font-size: 12px;
  color: #666;
  font-weight: 500;
  flex: 1;
`;

const Value = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: #262626;
  line-height: 1;
`;


const SummaryCard = ({ 
  title, 
  icon, 
  done, 
  undone, 
  color, 
  tooltip,
  onClick,
  disabled = false
}) => {
  const cardContent = (
    <Card color={color} onClick={disabled ? undefined : onClick} disabled={disabled}>
      <Header>
        <Icon color={color}>{icon}</Icon>
        <Title>{title}</Title>
      </Header>
      <Value>{done}</Value>
    </Card>
  );

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="top">
        {cardContent}
      </Tooltip>
    );
  }

  return cardContent;
};

export default SummaryCard;